









import { Vue, Component, Model, Watch, Prop } from "vue-property-decorator";
// import { component } from "vue-mce";
import Editor from '@tinymce/tinymce-vue';
import tinymce, { TinyMCE, BaseEditorSettings, BlobInfo } from "tinymce";
import { TOKENS, WPMediaRest, WPMedia, DEBUG, IWPMediaSizes, IWPMediaSize } from '@/loader';

tinymce.PluginManager.add("insertTokens", function (editor) {
	editor.ui.registry.addMenuButton("insertTokens", {
		text: "Insérer des jetons",
		icon: "insert-character",
		fetch(callback) {
			var items = TOKENS.map(t => ({ type: 'menuitem', text: t.title, onAction() { editor.insertContent(t.token); } }));
			callback(items);
		}
	});
});

const IMG_SIZES: Extract<keyof IWPMediaSizes, string>[] = ["full", "large", "medium_large", "medium"];
const MAX_IMG_WIDTH = 1024;

@Component({
	components: {
		// "v-tinymce": component,
		"v-tinymce": Editor,
	}
})
export default class TextEdit extends Vue {
	@Model("input", { type: String, default: null })
	public readonly value!: string | null;

	@Prop({ type: Boolean, default: false })
	public readonly canEdit!: boolean;

	@Prop({ type: Boolean, default: false })
	public readonly insertTokens!: boolean;

	public localValue: string = "";

	public get options(): BaseEditorSettings {
		let plugins = ["hr", "insertdatetime", "lists", "advlist", "nonbreaking", "pagebreak", "paste", "quickbars", "image"];
		if (this.insertTokens) {
			plugins.push("insertTokens");
		}
		return {
			plugins,
			language: "fr_FR",
			browser_spellcheck: true,
			menubar: false,
			branding: false,
			toolbar: "undo redo | copy cut paste pastetext | formatselect | forecolor backcolor | bold italic underline strikethrough superscript subscript | alignleft aligncenter alignright alignjustify | numlist bullist | outdent indent | image insertTokens hr pagebreak removeformat insertdatetime",
			// URL Handling: https://www.tiny.cloud/docs/configure/url-handling/
			relative_urls: false,
			convert_urls: false,
			// plugin quickbars: https://www.tiny.cloud/docs/plugins/opensource/quickbars/
			inline: false,
			quickbars_selection_toolbar: "formatselect | forecolor backcolor | bold italic underline strikethrough superscript subscript",
			quickbars_insert_toolbar: false,
			quickbars_image_toolbar: false,
			// plugin insertdatetime: https://www.tiny.cloud/docs/plugins/opensource/insertdatetime/
			insertdatetime_element: true,
			insertdatetime_formats: ["%d/%m/%Y", "%A %d/%m/%Y", "%A %d %B %Y", "%H:%M", "%H:%M:%S"],
			// plugins paste: https://www.tiny.cloud/docs/plugins/opensource/paste
			paste_data_images: false,
			// plugin image: https://www.tiny.cloud/docs/plugins/opensource/image
			image_advtab: true,
			images_upload_handler(blobInfo: BlobInfo, success: (url: string) => void, failure: (err: string, options?: UploadFailureOptions) => void, progress?: (percent: number) => void) {
				DEBUG && console.log(blobInfo);
				let m = new WPMedia({ status: "publish" });
				WPMediaRest.create(m, blobInfo.blob()).then(result => {
					if (result.success && result.item) {
						DEBUG && console.log(result.item);
						// Check which size is available and which one is the more appropriate
						let sizes = result.item.media_details.sizes;
						let size: IWPMediaSize | null = null;
						// 1) Check if the image is in portrait or landscape
						let side: "height" | "width" = result.item.media_details.height > result.item.media_details.width ? "height" : "width";
						// 2) Get the size immediately smaller than MAX_IMG_WIDTH
						// (IMG_SIZED should be sorted from larger to smaller)
						for (let s of IMG_SIZES) {
							if (sizes[s] && sizes[s][side] < MAX_IMG_WIDTH) {
								size = sizes[s];
								break;
							}
						}
						if (!size) {
							size = sizes.full;
						}

						success(size.source_url);
					} else {
						failure(result.error?.message || "La préparation de l'image a échoué");
					}
				});
			}
		}
	}

	@Watch("value", { immediate: true })
	public valueChanged(newValue: string | null, oldValue?: string | null) {
		// DEBUG && console.log("valueChanged", newValue?.length, oldValue?.length);
		if (newValue !== oldValue && newValue !== this.localValue) {
			this.localValue = newValue || "";
		}
	}

	@Watch("localValue")
	public localValueChanged(newValue: string, oldValue?: string) {
		if (newValue !== oldValue && newValue !== this.value) {
			this.$emit('input', newValue);
		}
	}
}
